export enum RouteCoachName {
  ACCUEIL_CONNECTEE = 'agir',
  BIBLIOTHEQUE = 'bibliotheque',
}
